import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { GlobalEventServiceService } from '@services/global-event-service.service';

let cellId = 1;

@Component({
  selector: 'app-button-cell-renderer',
  template: `
  <div style="height: 50px; padding: 4px;">
      <button mat-button class="light-bg-color"
        (click)="clicked()">
        {{label}}
      </button>
  </div>
`
})
export class ButtonCellRendererComponent {

  cellId = 1;

  id: any = '';

  eventName = 'assigned';

  label = 'Zuweisen';

  constructor(
    private eventService: GlobalEventServiceService
  ) {
    cellId++;
    this.cellId = cellId;

  }

  agInit(params: ICellRendererParams): void {
    if (params?.data?.id) {
      this.id = params.data.id;
    }
    const colDefParams = params?.colDef?.cellRendererParams;
    if(colDefParams) {
      if (colDefParams.eventName) {
        this.eventName = colDefParams.eventName;
      }
      if (colDefParams.label) {
        this.label = colDefParams.label;
      }
    }
  }

  refresh(_params: ICellRendererParams) {
    return false;
  }

  clicked() {
    this.eventService.sendEvent(this.eventName, this.id);
  }
}
